import React from 'react';
import { colors } from '@material-ui/core';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';

export default function VerifiedIcon(props) {
  return <VerifiedUserIcon style={{ color: colors.green[400] }} {...props} />;
}
